export enum IntegrationType {
  YemekSepeti,
  Getir,
  Trendyol,
  PaketServisi,
  MigrosYemek,
  Fuddy,
  GoFody,
}
